module.exports = __webpack_public_path__ + "img/warning2.f2ee7575.svg";